module.exports = __webpack_public_path__ + "img/services_gl.823d2036.jpg";